import { Platform } from 'react-native'

interface ThemeColors {
    textPrimary: string
    textSecondary: string
    colorPrimary: string
    colorSecondary: string
    colorTertiary: string
    colorApprovedEvaluation: string
    colorApproved: string
    colorCancelled: string
    colorPending: string
    colorInProgress: string
    colorLocked: string
    colorSeen: string
    colorRetry: string
    colorDisapproved: string
    error: string
    alert: string
    disabled: string
    background: string
    modalBackground: string
    formsBackground: string
    filtersBackground: string
    linearGradientStart: string
    linearGradientEnd: string
    linearGradientGreenStart: string
    linearGradientGreenEnd: string
    linearGradientRedStart: string
    linearGradientRedEnd: string
    neutralGray: string
    lightGray: string
    mediumGray: string
    darkGray: string
    colorHeart: string
    colorComment: string
    colorShare: string
    gamificationDotApprovedColor: string
    pageIndicatorBackground: string
    RankingFirstPlaceColor: string
    RankingSecondPlaceColor: string
    RankingThirdPlaceColor: string
    RankingPointsColor: string
    createScheduleBackgroundColor: string
    vacationDaySelectedColor: string
    floatPageIndicatorBackground: string
    storeFormButtonBackground: string
    storeItemTextAddressStoreWithGoTo: string

    //indicadores de tienda
    linearGradientStart00: string
    linearGradientEnd00: string
    linearGradientStart01: string
    linearGradientEnd01: string
    linearGradientStart02: string
    linearGradientEnd02: string
    linearGradientStart03: string
    linearGradientEnd03: string
    linearGradientStart04: string
    linearGradientEnd04: string
}

interface ThemeFontSizes {
    ultraBigText: number
    bigText: number
    normalText: number
    mediumText: number
    smallText: number
    ultraSmallText: number
}

interface ThemeFonts {
    main: string
}

interface ThemeFontWeights {
    light: string
    normal: string
    bold: string
}

interface ThemeFontStyles {
    normal: string
    italic: string
}

interface Theme {
    colors: ThemeColors
    fontSizes: ThemeFontSizes
    fonts: ThemeFonts
    fontWeights: ThemeFontWeights
    fontStyles: ThemeFontStyles
}

const theme: Theme = {
    colors: {
        textPrimary: '#0E0E2C',
        textSecondary: '#5C5C86',
        colorPrimary: '#05A688',
        colorSecondary: '#141319',
        colorTertiary: '#CF28B4',
        colorApprovedEvaluation: '#009E4D',
        colorApproved: '#009E4D',
        colorCancelled: '#E51D0D',
        colorPending: '#95919F',
        colorInProgress: '#CF28B4',
        colorLocked: '#5C5C86',
        colorSeen: '#141319',
        colorRetry: '#E51D0D',
        colorDisapproved: '#E51D0D',
        error: '#E51D0D',
        alert: '#FFDE39',
        disabled: '#DDDBE2',
        background: '#FFFFFF',
        modalBackground: '#F9FAFE',
        formsBackground: '#F1F2FF',
        filtersBackground: '#F1F2FF',
        linearGradientStart: '#822C7F',
        linearGradientEnd: '#05A688',
        linearGradientGreenStart: '#16823F',
        linearGradientGreenEnd: '#028754',
        linearGradientRedStart: '#C21818',
        linearGradientRedEnd: '#DA2121',
        neutralGray: '#DADADA',
        lightGray: '#CBCDE4',
        mediumGray: '#95919F',
        darkGray: '#5C5C86',
        colorHeart: '#E51D0D',
        colorComment: '#1C8CF7',
        colorShare: '#09B348',
        gamificationDotApprovedColor: '#53D06F',
        pageIndicatorBackground: '#FAFAFA',
        RankingFirstPlaceColor: '#E2BA61',
        RankingSecondPlaceColor: '#666666',
        RankingThirdPlaceColor: '#ED713B',
        RankingPointsColor: '#1C98F0',
        createScheduleBackgroundColor: '#E53935',
        vacationDaySelectedColor: '#141319',
        floatPageIndicatorBackground: '#FAFAFA',
        storeFormButtonBackground: '#F1F2FF',
        storeItemTextAddressStoreWithGoTo: '#6D85DA',
        linearGradientStart00: '#03827B',
        linearGradientEnd00: '#1A3BB1',
        linearGradientStart01: '#1A3BB1',
        linearGradientEnd01: '#822C7F',
        linearGradientStart02: '#822C7F',
        linearGradientEnd02: '#21273A',
        linearGradientStart03: '#0E0E2C',
        linearGradientEnd03: '#0E0E2C',
        linearGradientStart04: '#171D35',
        linearGradientEnd04: '#6560FA',
    },
    fontSizes: {
        ultraBigText: 18,
        bigText: 16,
        normalText: 15,
        mediumText: 14,
        smallText: 13,
        ultraSmallText: 12,
    },
    fonts: {
        main: Platform.select({
            android: 'System',
            ios: 'System',
            default: 'System',
        }) as string,
    },
    fontWeights: {
        light: '300',
        normal: '400',
        bold: '700',
    },
    fontStyles: {
        normal: 'normal',
        italic: 'italic',
    },
}

export default theme
export type { Theme, ThemeColors, ThemeFontSizes, ThemeFonts, ThemeFontWeights, ThemeFontStyles }
